import { ErrorFault } from "models/ErrorFault";
import React from "react";
import { ErrorToast } from "./ErrorToast";

type ErrorToastContainerProps = {
    toasts: ErrorFault[]
}

export const ErrorToastContainer: React.FC<ErrorToastContainerProps> = ({toasts}) => {
    return (
        <>
            {toasts !== null ? (
                <div className="toast-container p-3 top-0 end-0">
                    {toasts?.map((_item, _index) => (
                        <ErrorToast key={_index} {..._item} />
                    ))}
                </div>
            ) : (<></>)} 
        </>
    )
} 